import { render, staticRenderFns } from "./BillingTabs.vue?vue&type=template&id=540fdb48&scoped=true&"
import script from "./BillingTabs.vue?vue&type=script&lang=js&"
export * from "./BillingTabs.vue?vue&type=script&lang=js&"
import style0 from "./BillingTabs.vue?vue&type=style&index=0&id=540fdb48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540fdb48",
  null
  
)

component.options.__file = "BillingTabs.vue"
export default component.exports